<template>
  <div>
    <!--选择影像中心开始-->
    <van-nav-bar left-arrow @click-left="onClickLeft">
      <div slot="title">
        <van-dropdown-menu active-color="#323233">
          <van-dropdown-item
            v-model="agentErpCode"
            :options="agentList"
            title-class="icon"
            @change="changeAgent"
            @open="openmenu"
            @close="closemenu"
          />
        </van-dropdown-menu>
      </div>
    </van-nav-bar>
    <!--选择影像中心结束-->

    <div v-if="toggle">
      <van-dropdown-menu>
        <van-dropdown-item :title="date" ref="item">
          <van-datetime-picker
            v-model="currentDate"
            title="选择年月"
            type="year-month"
            @confirm="confirmDate"
            @cancel="cancelDate"
          />
        </van-dropdown-item>
        <van-dropdown-item v-model="value3" :options="option3" @change="confirmType"/>
      </van-dropdown-menu>
      <div v-if="record[0]">
        <van-cell
          v-for="(item,index) in record"
          :key="index"
          :title="item.transfer_num"
          is-link
          :value="item.nodename"
          @click="recordDetail(item.id)"
        />
        <van-row>
          <van-col offset="7" span="10">
            <van-button round icon="plus" type="primary" @click="addReturns">新建调拨单</van-button>
          </van-col>
        </van-row>
      
      </div>
      <!-- <van-empty v-else description="暂无盘点单" /> -->
      <van-empty v-else description="暂无调拨单">
        <van-button round icon="plus" type="primary" @click="addReturns">新建调拨单</van-button>
      </van-empty>
    </div>
    
    <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from "../../view/bottom/index.vue";
import Vue from "vue";
import {
  Sidebar,
  SidebarItem,
  IndexBar,
  IndexAnchor,
  NavBar,
  Tab,
  Tabs,
  Panel,
  Search,
  Tabbar,
  TabbarItem,
  Icon,
  DropdownMenu,
  DropdownItem,
  Button,
} from "vant";
import { Row, Col, Empty, DatetimePicker } from "vant";
import { mapState, mapMutations } from "vuex";
Vue.use(Col).use(Panel);
Vue.use(Icon);
Vue.use(DatetimePicker);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(IndexBar).use(IndexAnchor);
Vue.use(NavBar);
Vue.use(Tabs);
Vue.use(Search);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(Button);
export default {
  components: {
    Bottom,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Empty.name]: Empty,
  },

  data() {
    return {
      scroll: "scroll",
      contentheight: "",
      height: "",
      currentAgent: "",
      agentErpCode: "",
      agentList: [],
      toggle: true,
      record: [],
      currentDate: new Date(),
      value3: 0,
      option3: [],
      date:'选择年月',
      isAll:false,
    };
  },

  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
    classObject: function () {
      return {
        "overflow-y": "scroll",
        height: this.height,
      };
    },
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    parseDate(obj) {
      let year = obj.getFullYear();
      let month = obj.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      return year + "-" + month;
    },
    onClickLeft() {
      this.$router.push("index");
    },
    openmenu() {
      this.toggle = false;
    },
    closemenu() {
      if (this.agentErpCode) {
        this.toggle = true;
      }
    },
    addReturns() {
      this.$router.push("addallot");
    },
    parseAgentList(obj) {
      let newarr = [];
      for (let i = 0; i < obj.length; i++) {
        let newobj = {
          text: obj[i].name,
          value: obj[i].erp_code,
        };
        newarr.push(newobj);
      }
      return newarr;
    },
    
    parseNodeList(obj)
    {
      let newarr = [
        {
          text: "全部状态",
          value: 0,
        },
      ];
      for (let i = 0; i < obj.length; i++) {
        let newobj = {
          text: obj[i].name,
          value: obj[i].id,
        };
        newarr.push(newobj);
      }
      return newarr;
    },
    confirmDate() {
      this.$refs.item.toggle();
      this.date = this.parseDate(this.currentDate);
      this.isAll = true;
      this.handleAjax(this, this.agentErpCode, this.currentDate, this.value3, this.isAll);
    },
    cancelDate() {
      this.$refs.item.toggle();
      this.date = '选择年月';
      this.isAll = false;
      this.handleAjax(this, this.agentErpCode, this.currentDate, this.value3,this.isAll);
    },
    
    confirmType() {
      this.handleAjax(this, this.agentErpCode, this.currentDate, this.value3, this.isAll);
    },
    recordDetail(id) {
      this.$router.push({
        name: "allotdetail",
        query: {
          id: id,
          ms:this.currentDate.valueOf(),
          node:this.value3,
          isall:this.isAll
        },
      });
    },
    changeAgent(value) {
      if (value) {
        this.currentAgent = this.permissionAgent.find(function (item) {
          return item.erp_code == value;
        });
        this.changeDefaultAgentIndex(this.currentAgent.id);
        this.date = '选择年月';
        this.value3 = 0;
        this.isAll = false;
        this.handleAjax(this, this.agentErpCode, this.currentDate, this.value3,this.isAll);
      }
    },
    handleAjax(instance, erp, date, currentNode,flag) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      instance.$http
        .post("/mobile/transfer/mainList", {
          projectErpCode: erp,
          year: flag?year:'',
          month:flag?month:'',
          currentNode: currentNode,
        })
        .then(function (response) {
          instance.record = response.transferList;
        });
    },
  },
  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.agentList = this.parseAgentList(this.permissionAgent);
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.agentErpCode = this.currentAgent.erp_code;
      if (this.$route.query.ms && this.$route.query.isall) {
        this.currentDate = new Date(this.$route.query.ms);
        this.date = this.parseDate(this.currentDate);
        this.isAll = this.$route.query.isall;
      }
      if (this.$route.query.node) {
        this.value3 = this.$route.query.node
      }
      //获取节点列表
      this.$http
        .post("/mobile/transfer/getNodeList")
        .then(function (response) {
          _this.option3 = _this.parseNodeList(response.record);
        });

      this.handleAjax(this, this.agentErpCode, this.currentDate, this.value3, this.isAll);
    } else {
      //this.date = this.parseDate(this.currentDate);
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          _this.changePermissionAgent(response.rimsAgent);
          _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
          _this.agentList = _this.parseAgentList(response.rimsAgent);
          _this.agentErpCode = response.rimsAgent[0].erp_code;
          
          _this.currentAgent = response.rimsAgent[0];
          _this.handleAjax(_this, _this.agentErpCode, _this.currentDate, _this.value3, _this.isAll);
        });
      this.$http
        .post("/mobile/transfer/getNodeList")
        .then(function (response) {
          _this.option3 = _this.parseNodeList(response.record);
        });
    }
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 260 + "px";
    this.contentheight = document.documentElement.clientHeight - 200 + "px";
  },
};
</script>

<style lang="less" scopt>
#aaa {
  width: 100vw;
  height: 46px;
}
#bbb {
  width: 100vw;
  height: 40px;
}
#ccc {
  height: 50px;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.7);
}
.van-dropdown-menu {
  height: 46px;
}
.van-tab__pane,
.van-tab__pane-wrapper {
  height: 507px;
  overflow-y: scroll;
}

</style>
